import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import Login from "./components/Login";
import ForgotPassword from "./components/ForgotPassword";
import ResetPassword from "./components/ResetPassword";
import Dashboard from "./components/Dashboard";
import CompanyDetails from "./components/CompanyDetails";
import BlogManagement from "./components/BlogManagement";
import Post from "./components/Post";
import Postedit from "./components/Postedit";
import Createpost from "./components/Createpost";
import Careerlist from "./components/career/Careerlist";
import Createcareer from "./components/career/Createcareer";
import Careeredit from "./components/career/Careeredit";
import Careerapplication from "./components/career/Careerapplication";
import BlogList from "./components/Blog/BlogList";
import BlogForm from "./components/Blog/BlogForm";
import BlogDetail from "./components/Blog/BlogDetail";
import GalleryList from "./components/Gallery/GalleryList";
import GalleryUpload from "./components/Gallery/GalleryUpload";
import GalleryEdit from "./components/Gallery/GalleryEdit";

import Navbar from "./components/Navbar";
import Sidebar from "./components/Sidebar";

import "bootstrap/dist/css/bootstrap.min.css";
import PostEnquiries from "./components/PostEnquiries";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // Load user on mount
  useEffect(() => {
    const token = localStorage.getItem("access_token");
    const userData = localStorage.getItem("user");

    if (token && userData) {
      setIsAuthenticated(true);
      setUser(JSON.parse(userData));
    }
  }, []);

  // Handle login
  const handleLogin = (data) => {
    localStorage.setItem("access_token", data.access);
    localStorage.setItem("refresh_token", data.refresh);
    localStorage.setItem("user", JSON.stringify(data.user));
    setIsAuthenticated(true);
    setUser(data.user);
  };

  // Handle logout
  const handleLogout = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("user");
    setIsAuthenticated(false);
    setUser(null);
    setSidebarOpen(false);
  };

  // Toggle sidebar
  const toggleSidebar = () => {
    setSidebarOpen((prev) => !prev);
  };

  // Inline style for main content
  const getMainContentStyle = () => {
    const isMobile = window.innerWidth <= 768;
    const isLoginPage = window.location.pathname === "/login";
    return {
      flex: 1,
      transition: "margin-left 0.3s ease",
      padding: isLoginPage || isMobile ? "0px" : "0px",
      // padding: isMobile ? "0px" : "20px",
      marginTop: isAuthenticated ? "70px" : "0",
      marginLeft: isMobile
        ? "0"
        : sidebarOpen
          ? "250px"
          : isAuthenticated
            ? "70px"
            : "0",
    };
  };

  return (
    <Router>
      <div className="App">
        {isAuthenticated && (
          <>
            <Navbar
              user={user}
              onLogout={handleLogout}
              toggleSidebar={toggleSidebar}
              sidebarOpen={sidebarOpen}
            />
            <Sidebar
              isOpen={sidebarOpen}
              toggleSidebar={toggleSidebar}
              onLogout={handleLogout}
              user={user}
            />
          </>
        )}

        {/* Main content */}
        <div
          style={getMainContentStyle()}
          onClick={() => {
            // Auto-close sidebar on mobile when clicking outside
            if (sidebarOpen && window.innerWidth <= 768) {
              setSidebarOpen(false);
            }
          }}
        >
          <Routes>
            {/* Auth routes */}
            <Route
              path="/login"
              element={
                isAuthenticated ? (
                  <Navigate to="/dashboard" />
                ) : (
                  <Login onLogin={handleLogin} />
                )
              }
            />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />

            {/* Protected routes */}
            <Route
              path="/dashboard"
              element={
                isAuthenticated ? (
                  <Dashboard user={user} />
                ) : (
                  <Navigate to="/login" />
                )
              }
            />
            <Route
              path="/company-details"
              element={
                isAuthenticated ? (
                  <CompanyDetails user={user} />
                ) : (
                  <Navigate to="/login" />
                )
              }
            />
            <Route
              path="/blog-management"
              element={
                isAuthenticated ? (
                  <BlogManagement user={user} />
                ) : (
                  <Navigate to="/login" />
                )
              }
            />
            <Route
              path="/post"
              element={
                isAuthenticated ? (
                  <Post user={user} />
                ) : (
                  <Navigate to="/login" />
                )
              }
            />
            <Route
              path="/posts/enquiries"
              element={
                isAuthenticated ? (
                  <PostEnquiries user={user} />
                ) : (
                  <Navigate to="/login" />
                )
              }
            />

            <Route
              path="/posts/edit/:id"
              element={
                isAuthenticated ? (
                  <Postedit user={user} />
                ) : (
                  <Navigate to="/login" />
                )
              }
            />
            <Route
              path="/posts/create"
              element={
                isAuthenticated ? (
                  <Createpost user={user} />
                ) : (
                  <Navigate to="/login" />
                )
              }
            />
            <Route
              path="/careers"
              element={
                isAuthenticated ? (
                  <Careerlist user={user} />
                ) : (
                  <Navigate to="/login" />
                )
              }
            />
            <Route
              path="/careers/create"
              element={
                isAuthenticated ? (
                  <Createcareer user={user} />
                ) : (
                  <Navigate to="/login" />
                )
              }
            />
            <Route
              path="/careers/edit/:id"
              element={
                isAuthenticated ? (
                  <Careeredit user={user} />
                ) : (
                  <Navigate to="/login" />
                )
              }
            />
            <Route
              path="/careers/applications"
              element={
                isAuthenticated ? (
                  <Careerapplication user={user} />
                ) : (
                  <Navigate to="/login" />
                )
              }
            />
            <Route
              path="/blogs"
              element={
                isAuthenticated ? <BlogList /> : <Navigate to="/login" />
              }
            />
            <Route
              path="/blogs/create"
              element={
                isAuthenticated ? <BlogForm /> : <Navigate to="/login" />
              }
            />
            <Route
              path="/blogs/edit/:id"
              element={
                isAuthenticated ? <BlogForm /> : <Navigate to="/login" />
              }
            />
            <Route
              path="/blogs/:id"
              element={
                isAuthenticated ? <BlogDetail /> : <Navigate to="/login" />
              }
            />
            <Route
              path="/gallery"
              element={
                isAuthenticated ? (
                  <GalleryList user={user} />
                ) : (
                  <Navigate to="/login" />
                )
              }
            />
            <Route
              path="/gallery/upload"
              element={
                isAuthenticated ? (
                  <GalleryUpload user={user} />
                ) : (
                  <Navigate to="/login" />
                )
              }
            />
            <Route
              path="/gallery/edit/:id"
              element={
                isAuthenticated ? (
                  <GalleryEdit user={user} />
                ) : (
                  <Navigate to="/login" />
                )
              }
            />

            {/* Default route */}
            <Route
              path="/"
              element={
                isAuthenticated ? (
                  <Navigate to="/dashboard" />
                ) : (
                  <Navigate to="/login" />
                )
              }
            />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
